var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletUnSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5653_1558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5365 4.42692C22.4018 2.68787 20.9447 1.31378 19.1717 1.31378H3.37607C1.5145 1.31378 0 2.82828 0 4.68986V20.3102C0 22.1718 1.5145 23.6863 3.37607 23.6863H21.624C23.4855 23.6863 25.0001 22.1718 25.0001 20.3102V7.67662C25 6.13132 23.956 4.82613 22.5365 4.42692ZM3.37607 2.89093H19.1718C20.03 2.89093 20.7493 3.49522 20.9278 4.3006H3.37607C2.7151 4.3006 2.09839 4.49227 1.57714 4.82189V4.68986C1.57714 3.69793 2.38415 2.89093 3.37607 2.89093ZM21.6239 22.1091H3.37607C2.38415 22.1091 1.57714 21.3021 1.57714 20.3102V7.67662C1.57714 6.6847 2.38415 5.87769 3.37607 5.87769H21.624C22.6159 5.87769 23.4229 6.6847 23.4229 7.67662V10.4286H18.3945C16.4019 10.4286 14.7807 12.0498 14.7807 14.0424C14.7807 16.035 16.4019 17.6562 18.3945 17.6562H23.4229V20.3102C23.4229 21.3021 22.6159 22.1091 21.6239 22.1091ZM23.4229 16.0791H18.3945C17.2715 16.0791 16.3579 15.1654 16.3579 14.0424C16.3579 12.9194 17.2715 12.0058 18.3945 12.0058H23.4229V16.0791Z",
    fill: "#484888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6872 14.9233C19.1406 14.9233 19.5082 14.5557 19.5082 14.1023C19.5082 13.6488 19.1406 13.2812 18.6872 13.2812C18.2338 13.2812 17.8662 13.6488 17.8662 14.1023C17.8662 14.5557 18.2338 14.9233 18.6872 14.9233Z",
    fill: "#484888"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5653_1558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletUnSelected);
export default __webpack_public_path__ + "static/media/walletUnSelected.7a1a0acf5e528211c5786673d8599482.svg";
export { ForwardRef as ReactComponent };